import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const HyperLink = ({
  height = 16,
  width = 16,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => {
  return (
    <SvgIcon height={height} width={width} viewBox="0 0 16 16" {...props}>
      <path
        d="M6.46233 11.7917L5.91867 12.3353C5.42638 12.8276 4.7587 13.1042 4.0625 13.1042C3.3663 13.1042 2.69862 12.8276 2.20633 12.3353C1.71405 11.8431 1.43748 11.1754 1.43748 10.4792C1.43748 9.78298 1.71405 9.1153 2.20633 8.62301L4.99058 5.83818C5.45738 5.37032 6.08347 5.09577 6.74384 5.06933C7.40421 5.0429 8.05025 5.26653 8.55294 5.69557C9.05564 6.12462 9.378 6.72749 9.45566 7.38381C9.53331 8.04013 9.36053 8.70159 8.97183 9.23609"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.64384 4.24743L10.0813 3.80993C10.5736 3.31764 11.2413 3.04108 11.9375 3.04108C12.6337 3.04108 13.3014 3.31764 13.7937 3.80993C14.286 4.30221 14.5625 4.9699 14.5625 5.66609C14.5625 6.36229 14.286 7.02997 13.7937 7.52226L11.0094 10.3065C10.5425 10.7742 9.91643 11.0485 9.25613 11.0748C8.59583 11.1011 7.94991 10.8773 7.44733 10.4483C6.94476 10.0192 6.62251 9.41634 6.54491 8.76008C6.46732 8.10383 6.6401 7.44246 7.02876 6.90801"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
};
